module.exports = __webpack_public_path__ + "static/img/u157.881282b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u157.png
// module id = auPh
// module chunks = 0